module.exports = __webpack_public_path__ + "static/media/3.6_preview.f33d2fd9.png";